// Portfolio Administration v1.0 PR 4b §7.8 — empty state for the
// Defaults & Workout tab. Rendered when the loan has no DefaultCase
// outside the closed-final terminal state. Shows the rationale users
// expect (auto-open triggers) and a single CTA to open one manually.

import { ShieldCheck } from "lucide-react";
import { Button, Card } from "@/design-system/components/ui";

interface NoActiveDefaultEmptyStateProps {
  canOpenManually: boolean;
  onOpenManually: () => void;
}

export function NoActiveDefaultEmptyState({
  canOpenManually,
  onOpenManually,
}: NoActiveDefaultEmptyStateProps) {
  return (
    <Card data-testid="defaults-empty-state">
      <div className="flex items-start gap-space-3">
        <ShieldCheck
          className="text-status-success shrink-0"
          size={28}
          aria-hidden
        />
        <div className="flex-1">
          <h2 className="font-display font-bold text-h3 m-0 mb-space-1">
            No active default
          </h2>
          <p className="text-small text-gray-mid m-0 mb-space-3">
            This loan is in good standing. Default cases are auto-opened by the
            system when insurance lapses, UCC filings lapse, payments are 60+
            days delinquent, or covenant tests fail past their cure deadlines.
          </p>
          {canOpenManually && (
            <Button
              variant="secondary"
              size="sm"
              onClick={onOpenManually}
              data-testid="defaults-open-manually-button"
            >
              Open default case manually
            </Button>
          )}
        </div>
      </div>
    </Card>
  );
}
